export default __webpack_public_path__ + "static/media/hh3.a7fb665f.png";